import { apiRequest } from './client';

export const fetchMeetings = (status = '') => {
  const query = status && status !== 'ALL' ? `?status=${encodeURIComponent(status)}` : '';
  return apiRequest(`/meetings${query}`);
};

export const fetchMeetingById = (id) => {
  return apiRequest(`/meetings/${encodeURIComponent(id)}`);
};

export const fetchMeetingByRoomId = (roomId) => {
  return apiRequest(`/meetings/room/${encodeURIComponent(roomId)}`);
};

export const createMeeting = (data) => {
  return apiRequest('/meetings', {
    method: 'POST',
    body: data
  });
};

export const updateMeeting = (id, data) => {
  return apiRequest(`/meetings/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: data
  });
};

export const cancelMeeting = (id) => {
  return apiRequest(`/meetings/${encodeURIComponent(id)}`, {
    method: 'DELETE'
  });
};

export const startMeeting = (roomId) => {
  return apiRequest(`/meetings/room/${encodeURIComponent(roomId)}/start`, {
    method: 'POST'
  });
};

export const endMeeting = (roomId) => {
  return apiRequest(`/meetings/room/${encodeURIComponent(roomId)}/end`, {
    method: 'POST'
  });
};

export const joinMeetingRoom = (roomId, data = {}) => {
  return apiRequest(`/meetings/room/${encodeURIComponent(roomId)}/join`, {
    method: 'POST',
    body: data
  });
};

export const leaveMeetingRoom = (roomId) => {
  return apiRequest(`/meetings/room/${encodeURIComponent(roomId)}/leave`, {
    method: 'POST'
  });
};

export const sendMeetingChatMessage = (roomId, messageData) => {
  return apiRequest(`/meetings/room/${encodeURIComponent(roomId)}/chat`, {
    method: 'POST',
    body: messageData
  });
};

export const fetchMeetingChatMessages = (roomId) => {
  return apiRequest(`/meetings/room/${encodeURIComponent(roomId)}/chat`);
};

export const fetchMeetingInvitees = () => {
  return apiRequest('/meetings/invitees');
};
